module.exports = __webpack_public_path__ + "c2c20825a6d948b4512cf668be3beba2.pdf";